// eslint-disable-next-line import/no-unresolved
import auth from '@/middleware/auth'

const formTable = [
  // CREATIONS
  {
    path: '/conditions-generals-flights/list',
    name: 'conditions-generals-flights-list',
    // eslint-disable-next-line import/no-unresolved
    component: () => import('@/views/nomencladores/flights/ConditionGeneral.vue'),
    meta: {
      layout: 'content',
      middleware: auth,
      pertenece: 'nom_conditions_generals_fligths',
    },
  },
  {
    path: '/conditions-generals-flights/update',
    name: 'conditions-generals-flights-update',
    // eslint-disable-next-line import/no-unresolved
    component: () => import('@/views/nomencladores/flights/form/ConditionsGeneral.vue'),
    meta: {
      layout: 'content',
      middleware: auth,
      pertenece: 'nom_conditions_generals_flights',
    },
  },
]

export default formTable
